// PrivateRoute.tsx in v6
import { useSelector } from 'react-redux';
import { Navigate, Route, useLocation } from 'react-router-dom';
import AdminNavBar from "./admin/AdminNavBar";
import AdminSideBar from "./admin/AdminSideBar";

const SuperAdminRoute = ({ children }) => {
  let location = useLocation();

  const { isSuperAdmin, loading } = useSelector(state => state.auth);

  if (loading) {
    return <p>Checking authenticaton..</p>;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return (
    <>
    <AdminNavBar />
    <div className="container">
      <div class="admin-container">
        <div class="admin-side-nav">
          <AdminSideBar />
        </div>
        <div class="admin-content">
          {children}
        </div>
      </div>
    </div>
    </>
  ) 
};

export default SuperAdminRoute;